import {
    GET_ALL_INFORMATION_REQUEST,
} from "./actionTypes"

export const getAllInformation = () => ({
    type: GET_ALL_INFORMATION_REQUEST
})

